import create from "zustand";

const useStore = create((set) => ({
  me: true,
  others: true,
  set: (key, value) => set((state) => ({ ...state, [key]: value })),
}));

export default useStore;
